import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Flatpickr from 'react-flatpickr';
import { Link, withRouter } from 'react-router-dom';
import Select from 'react-select';

import { debounce } from 'lodash';
import moment from 'moment';
import qs from 'query-string';

import 'flatpickr/dist/plugins/monthSelect/style.css';
import 'flatpickr/dist/themes/material_blue.css';
import placeholderImage from '../../../assets/images/placeholder.jpg';
import AlertService from '../../../components/SweetAlert';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';
import { GET, POST, PUT, newFetch } from '../../../helpers/fetch';
import ActivitySidebar from './ActivitySidebar';
import AssociateSidebar from './AssignAssociateSidebar';

import { config } from '../../../config/index';
const { API_URL, SERVER_URL } = config;

const SpreadsheetView = ({
  history,
  location: { search },
  activeSite,
  siteAssociateList,
  selectedDate,
  setSelectedDate,
  setShowModalShifts,
  showModalShifts,
  sites = [],
  selectedSiteID,
  clientID,
}) => {
  const pickerRef = useRef(null);
  const params = qs.parse(search, { ignoreQueryPrefix: true });
  const [hoveredItem, setHoveredItem] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const today = new Date();

  const [selectedAssociate, setSelectedAssociate] = useState(null);
  const [activeSidebar, setActiveSidebar] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));

  const [selectedYear, setSelectedYear] = useState(
    (params.spreadsheetViewDate && params.spreadsheetViewDate.split('-')[1]) ||
      new Date().getFullYear()
  );
  const [selectedMonth, setSelectedMonth] = useState(
    (params.spreadsheetViewDate && params.spreadsheetViewDate.split('-')[0]) ||
      new Date().getMonth() + 1
  );
  const [searchFilter, setSearchFilter] = React.useState(null);
  const [statuses, setStatuses] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [selectedShift, setSelectedShift] = useState(
    params.selectedShift ? JSON.parse(params.selectedShift) : []
  );
  const [shiftDay, setShiftDay] = useState([
    { value: 0, label: 'Sunday' },
    { value: 1, label: 'Monday' },
    { value: 2, label: 'Tuesday' },
    { value: 3, label: 'Wednesday' },
    { value: 4, label: 'Thursday' },
    { value: 5, label: 'Friday' },
    { value: 6, label: 'Saturday' },
  ]);
  const [OTOptions, setOTOptions] = useState([
    { value: 1, label: 'OT Before Shift' },
    { value: 2, label: 'OT After Shift' },
  ]);

  const [selectedShiftDay, setSelectedShiftDay] = useState(
    params.selectedShiftDay ? JSON.parse(params.selectedShiftDay) : []
  );
  const [associateSchedule, setAssociateSchedule] = useState([]);
  const [spreadsheetViewAssignShift, setSpreadsheetViewAssignShift] =
    useState(false);
  const [page, setPage] = React.useState(1);
  const [hasMore, setHasMore] = React.useState(true);
  const [loadingData, setLoadingData] = React.useState(true);
  const [pullingData, setPullingData] = React.useState(false);
  const hasMoreRef = React.useRef(hasMore);
  const triggerFetch = React.useRef(null);
  const pageSize = 100;
  const [selectedAssociates, setSelectedAssociates] = useState(
    Array.isArray(params.associateIds)
      ? params.associateIds
      : params.associateIds
      ? [params.associateIds]
      : []
  );
  const [selectedStatus, setSelectedStatus] = useState(
    params.selectedStatus
      ? JSON.parse(params.selectedStatus)
      : [
          { value: 1, label: 'Assigned' },
          { value: 2, label: 'On Time' },
          { value: 3, label: 'Late' },
          { value: 500, label: 'On Leave' },
        ]
  );
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null);
  const [filteredAssociates, setFilteredAssociates] = useState([]);
  const [associatesList, setAssociatesList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedShiftDate, setSelectedShiftDate] = useState(
    params.spreadsheetViewShiftDate || ''
  );
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOTType, setSelectedOTType] = useState(
    params.selectedOTType ? JSON.parse(params.selectedOTType) : []
  );
  const containerRef = useRef(null);
  const allSitesSelected = Number(selectedSiteID) === 0;
  const availableSiteIds = sites.map((site) => site.id);
  const effectiveAssociateList = allSitesSelected
    ? associatesList
    : siteAssociateList;
  const getAssociateDisplayName = (associateId) => {
    const associate = effectiveAssociateList.find(
      (item) => Number(item.id) === Number(associateId)
    );

    return associate
      ? `${associate.first_name || ''} ${associate.last_name || ''}`.trim()
      : String(associateId);
  };
  const siteFilterQuery = allSitesSelected
    ? `?${qs.stringify({
        client_id: clientID,
        site_ids: availableSiteIds.join(','),
      })}`
    : '';

  const selectRemoveAssociateHandler = (assocId) => {
    if (selectedAssociates.some((id) => id === String(assocId))) {
      setSelectedAssociates(
        [...selectedAssociates].filter((id) => id !== String(assocId))
      );
    } else {
      setSelectedAssociates([...selectedAssociates, String(assocId)]);
    }
  };

  const searchHandler = (e) => {
    if (e.target.value) {
      let filtered = [...effectiveAssociateList].filter((associate) => {
        let name = `${associate.first_name} ${associate.last_name}`;
        return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
      });
      setFilteredAssociates(filtered);
    } else {
      setFilteredAssociates(effectiveAssociateList);
    }
  };

  const handleMouseEnter = (employeeId, field, content, event) => {
    const element = event.target;
    if (element.scrollWidth >= element.clientWidth || content.length > 20) {
      setHoveredItem({ employeeId, field, content });
      setMousePosition({ x: event.clientX, y: event.clientY });
    }
  };

  const handleMouseMove = (event) => {
    setMousePosition({ x: event.clientX, y: event.clientY });
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  const fetchAssociatesByMonth = async (page, value = '') => {
    if (page != 1) {
      setPullingData(true);
    }

    let url = `/schedule/site/${activeSite.id}`;
    try {
      let response = await newFetch(POST, url, {
        searchFilter: value,
        display: pageSize,
        page,
        month: selectedMonth,
        year: selectedYear,
        shiftDate: selectedShiftDate.split('-').reverse().join('-'),
        status: selectedStatus.map((opt) => opt.value),
        shift: selectedShift.map((opt) => opt.value),
        shiftDay: selectedShiftDay.map((opt) => opt.value),
        associateIds: selectedAssociates,
        otType: selectedOTType,
        client_id: clientID,
        site_ids: allSitesSelected ? availableSiteIds : [activeSite.id],
      });

      if (response.success) {
        const newItems = response.data.result || [];
        const pagesCount = response.data.total_rows / pageSize;
        setAssociatesList(
          (response.data.list_assoc || []).map((associate) => ({
            ...associate,
            id: associate.id ?? associate.associate_id,
          }))
        );

        if (newItems.length < pageSize) {
          setHasMore(false);
          hasMoreRef.current = false;
        } else {
          setHasMore(true);
          hasMoreRef.current = true;
        }

        if (newItems.length > 0) {
          triggerFetch.current = false;
          setAssociateSchedule((prevItems) => {
            if (page === 1) {
              prevItems = [];
            }
            return [...prevItems, ...newItems];
          });
        } else {
          setAssociateSchedule((prevItems) => {
            if (page === 1 && response.data.total_rows == 0) {
              //|| prevItems.length == 0
              prevItems = [];
            }
            return [...prevItems, ...newItems];
          });
        }
      } else {
        console.log('Failed to fetch associateSchedule');
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingData(false);
      setPullingData(false);
    }
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      fetchAssociatesByMonth(1, value);
    }, 500),
    [activeSite, selectedMonth, selectedYear]
  );

  const handleSearchFilter = async (event) => {
    setAssociateSchedule([]);
    setPage(1);
    setSearchFilter(event.target.value);
    debouncedSearch(event.target.value);
    setLoadingData(true);
  };

  const fetchFilterStatuses = async () => {
    let api_path = `/status/site/${activeSite.id}/month/${selectedMonth}/year/${selectedYear}${siteFilterQuery}`;
    let response = await newFetch(GET, api_path);
    if (response.success) {
      setStatuses(response.data);
    }
  };

  const fetchStatuses = async () => {
    let api_path = `/attendanceStatus`;
    let response = await newFetch(GET, api_path);
    if (response.success) {
      let statuses = response.data;
      const preferredOption = { value: 600, label: 'Preferred' };
      setStatuses([
        ...statuses
          .filter((x) => x.id !== 4 && x.id !== 5)
          .map((item) => ({
            value: item.id,
            label: item.status,
          })),
        { value: 500, label: 'On Leave' },
        ...(activeSite.enable_preferred_schedule ||
        (allSitesSelected &&
          sites.some((site) => site.enable_preferred_schedule))
          ? [preferredOption]
          : []),
      ]);
    }
  };

  const fetchShiftsBySiteId = async () => {
    let api_path = `/shifts/site/${activeSite.id}/month/${selectedMonth}/year/${selectedYear}${siteFilterQuery}`;
    let response = await newFetch(GET, api_path);
    if (response.success) {
      setShifts(
        response.data.map((item) => ({
          value: item.shift_id,
          label: allSitesSelected
            ? `${item.site_name} - ${item.shift_name}`
            : item.shift_name,
          site_id: item.site_id,
          site_name: item.site_name,
        }))
      );
    }
  };

  const handleScroll = async () => {
    if (
      hasMoreRef.current &&
      window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - 10 &&
      !loadingData
    ) {
      await loadMore();
    }
  };

  const debouncedHandleScroll = React.useMemo(
    () => debounce(handleScroll, 300),
    [loadingData, hasMoreRef.current]
  );

  const loadMore = async () => {
    setPage((prevPage) => prevPage + 1);
  };

  const splitDateTime = (datetime) => {
    const dt = moment(datetime);
    return {
      date: dt.format('YYYY-MM-DD'),
      time: dt.format('HH:mm'),
    };
  };

  const handleAssignAssociate = async () => {
    setSpreadsheetViewAssignShift(true);
  };

  const formatDateLocal = (date, test) => {
    return moment(date).format('YYYY-MM-DD');
  };

  const handleChange = (id, field, value) => {
    setSelectedAssociate(id);
    setAssociateSchedule((prev) =>
      prev.map((assoc) =>
        assoc.associate_schedule_id === id
          ? { ...assoc, [field]: value, has_changes: true }
          : assoc
      )
    );
  };

  const handleChangeSave = (id, field, value) => {
    setAssociateSchedule((prev) =>
      prev.map((assoc) =>
        assoc.associate_schedule_id === id
          ? { ...assoc, [field]: value, has_changes: false }
          : assoc
      )
    );
  };

  const [firstPart, secondPart] = params?.spreadsheetViewDate
    ? params?.spreadsheetViewDate.split('-')
    : '';
  const [startOfMonth, setStartOfMonth] = useState(
    params?.spreadsheetViewDate
      ? formatDateLocal(new Date(secondPart, firstPart - 1, 1))
      : formatDateLocal(new Date(today.getFullYear(), today.getMonth(), 1))
  );

  const [lastDayOfMonth, setLastDayOfMonth] = useState(
    formatDateLocal(new Date(today.getFullYear(), today.getMonth() + 1, 0))
  );

  const calculateOvertime = async (
    schedId,
    updatedField = null,
    updatedValue = null
  ) => {
    // Get current assoc and apply any pending update
    const currentAssoc = associateSchedule.find(
      (assoc) => assoc.associate_schedule_id === schedId
    );

    if (!currentAssoc) return 0;
    if (![2, 3, 4, 5].includes(currentAssoc.status_id)) return 0;

    const assoc = {
      ...currentAssoc,
      ...(updatedField ? { [updatedField]: updatedValue } : {}),
    };

    // If BOTH overtime checkboxes are unchecked, reset overtime to 0
    if (!assoc.is_overtime_before && !assoc.is_overtime_after) {
      setAssociateSchedule((prev) =>
        prev.map((a) =>
          a.associate_schedule_id === schedId
            ? {
                ...a,
                [updatedField]: updatedValue,
                total_overtime: 0,
                has_changes: true,
              }
            : a
        )
      );
      return 0;
    }

    const shiftStart = moment(
      `${assoc.schedule_date} ${moment(assoc.start_time, 'HH:mm:ss').format(
        'HH:mm'
      )}`,
      'YYYY-MM-DD HH:mm'
    );

    const shiftEnd = moment(
      `${assoc.schedule_date} ${moment(assoc.end_time, 'HH:mm:ss').format(
        'HH:mm'
      )}`,
      'YYYY-MM-DD HH:mm'
    );
    if (shiftEnd.isBefore(shiftStart)) shiftEnd.add(1, 'days');

    const timeInMoment = assoc.time_in
      ? moment(assoc.time_in, 'YYYY-MM-DD HH:mm')
      : null;

    const timeOutMoment = assoc.time_out
      ? moment(assoc.time_out, 'YYYY-MM-DD HH:mm')
      : null;

    const shiftDate = moment(assoc.schedule_date);
    const isWeekend = shiftDate.day() === 0 || shiftDate.day() === 6;

    let overtimeHours = 0;

    // Only calculate overtime if at least one checkbox is checked
    if (assoc.is_overtime_before || assoc.is_overtime_after) {
      let workedHours = 0;
      if (timeInMoment && timeOutMoment) {
        workedHours = moment
          .duration(timeOutMoment.diff(timeInMoment))
          .asHours();
      }

      if (isWeekend && timeInMoment && timeOutMoment) {
        // Weekend: Full day counts as overtime, but respect checkbox selections
        overtimeHours = workedHours;

        // Deduct non-overtime periods based on checkboxes
        if (!assoc.is_overtime_before && timeInMoment) {
          const diffBefore = shiftStart.diff(timeInMoment, 'hours', true);
          if (diffBefore > 0) overtimeHours -= diffBefore;
        }

        if (!assoc.is_overtime_after && timeOutMoment) {
          const diffAfter = timeOutMoment.diff(shiftEnd, 'hours', true);
          if (diffAfter > 0) overtimeHours -= diffAfter;
        }
      } else {
        // Weekday: Only calculate checked overtime periods
        if (assoc.is_overtime_before && timeInMoment) {
          const diffBefore = shiftStart.diff(timeInMoment, 'hours', true);
          if (diffBefore > 0) overtimeHours += diffBefore;
        }

        if (assoc.is_overtime_after && timeOutMoment) {
          const diffAfter = timeOutMoment.diff(shiftEnd, 'hours', true);
          if (diffAfter > 0) overtimeHours += diffAfter;
        }
      }

      // Apply break deduction if > 8 hours total
      if (overtimeHours > 8) overtimeHours -= 1;
    }

    // Ensure no negative overtime
    overtimeHours = Math.max(0, overtimeHours);

    setAssociateSchedule((prev) =>
      prev.map((a) =>
        a.associate_schedule_id === schedId
          ? {
              ...a,
              [updatedField]: updatedValue,
              total_overtime: overtimeHours,
              has_changes: true,
            }
          : a
      )
    );

    return overtimeHours;
  };

  const parseDate = (value, format) => {
    const m = moment(value, format, true);
    return m.isValid() ? m : null;
  };

  const saveAssociateSchedule = async (
    assoc_id,
    sched_id,
    associateScheduleId
  ) => {
    const isInvalid = (val) =>
      !val || !moment(val, 'YYYY-MM-DD HH:mm', true).isValid();

    const associateData = associateSchedule.find(
      (assoc) => assoc.associate_schedule_id == associateScheduleId
    );

    let data = {};

    if (associateData.status_id != 1 && associateData.status_id != 7) {
      if (
        associateData.status_id == 1 &&
        (isInvalid(associateData.time_in) || isInvalid(associateData.time_out))
      ) {
        ToastUtil.error('Please select On Time or Late.');
        return false;
      }

      if (
        isInvalid(associateData.time_in) ||
        isInvalid(associateData.time_out)
      ) {
        ToastUtil.error('Please enter time in and time out.');
        return false;
      }

      if (associateData.time_in) {
        const inputDate = moment(
          associateData.time_in,
          'YYYY-MM-DD HH:mm'
        ).format('YYYY-MM-DD');
        const scheduleDate = moment(
          associateData.schedule_date,
          'YYYY-MM-DD '
        ).format('YYYY-MM-DD');

        if (inputDate !== scheduleDate) {
          ToastUtil.error('Time In date must be the same as the shift date.');
          return false;
        }
      }

      const shiftStart = moment(
        `${associateData.schedule_date} ${associateData.start_time}`,
        'YYYY-MM-DD HH:mm:ss'
      );
      const shiftEnd = moment(
        `${associateData.schedule_date} ${associateData.end_time}`,
        'YYYY-MM-DD HH:mm:ss'
      );

      const timeInMoment = parseDate(associateData.time_in, 'YYYY-MM-DD HH:mm');
      const timeOutMoment = parseDate(
        associateData.time_out,
        'YYYY-MM-DD HH:mm'
      );

      const shiftDate = moment(associateData.schedule_date);
      const isWeekend = shiftDate.day() === 0 || shiftDate.day() === 6;

      // Validation
      if (associateData.is_overtime_before && !timeInMoment) {
        ToastUtil.error('Time In is required for Overtime - Before Shift.');
        return false;
      }
      if (associateData.is_overtime_after && !timeOutMoment) {
        ToastUtil.error('Time Out is required for Overtime - After Shift.');
        return false;
      }

      const isConfirmed = await AlertService.confirm(
        '',
        'Are you sure you want to update this Associate?'
      );
      if (!isConfirmed) return;

      data = {
        status: Number(associateData.status_id),
        associate_ids: [assoc_id],
        is_overtime_after: associateData.is_overtime_after,
        is_overtime_before: associateData.is_overtime_before,
        is_undertime: associateData.is_undertime,
        remarks: associateData.remarks,
        total_overtime: associateData.total_overtime,
        total_break: associateData.total_break,
      };

      if (timeInMoment) {
        data.time_in = timeInMoment.format('YYYY-MM-DD HH:mm');
      }
      if (timeOutMoment) {
        data.time_out = timeOutMoment.format('YYYY-MM-DD HH:mm');
      }
    } else {
      data = {
        status: Number(associateData.status_id),
        associate_ids: [assoc_id],
        is_overtime_after: false,
        is_overtime_before: false,
        is_undertime: false,
        remarks: associateData.remarks,
        total_overtime: 0,
        total_break: 0,
      };
    }

    handleChangeSave(
      associateScheduleId,
      'date_modified',
      moment().format('DD/MM/YYYY HH:mm:ss')
    );
    handleChangeSave(associateScheduleId, 'has_changes', false);

    let api_path = `/schedule/${sched_id}/associate_update`;
    let response = await newFetch(PUT, api_path, data);

    ToastUtil.success(response.message);
  };

  const clearFilterHandler = async () => {
    setSelectedDate(`${today.getMonth() + 1}-${today.getFullYear()}`);
    setStartOfMonth(
      formatDateLocal(new Date(today.getFullYear(), today.getMonth(), 1))
    );
    setLastDayOfMonth(
      formatDateLocal(new Date(today.getFullYear(), today.getMonth() + 1, 0))
    );
    setSelectedYear(new Date().getFullYear());
    setSelectedMonth(new Date().getMonth() + 1);
    setSearchFilter('');
    setSelectedStatus([]);
    setSelectedShift([]);
    setSelectedShiftDate('');
  };

  const removeItem = (item, e) => {
    e.stopPropagation();
    setSelectedAssociates(selectedAssociates.filter((x) => x !== item));
  };

  const clearAll = (e) => {
    e.stopPropagation();
    setSelectedAssociates([]);
  };

  const sidebarHandler = async (assoc) => {
    setSelectedAssociate(assoc || []);
    setActiveSidebar(true);
  };

  const handleAssignToShift = async (e, assoc_id, sched_id) => {
    e.preventDefault();
    const isConfirmed = await AlertService.confirm(
      '',
      'Are you sure you want to assign the Associates to this shift?'
    );
    if (isConfirmed && sched_id && sched_id != 0 && assoc_id) {
      let url = `/associate/shifts/${sched_id}/assign`;

      try {
        let data = { associate_ids: [assoc_id] };

        let responseData = await newFetch(PUT, url, data);

        if (responseData.success) {
          ToastUtil.success(responseData.message);
          fetchAssociatesByMonth(1);
        } else {
          ToastUtil.error(
            responseData.data.fail.find((failAssociate) =>
              [assoc_id].includes(failAssociate.associate_id)
            ).message
          );
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (page != 1 && !loadingData) {
      fetchAssociatesByMonth(page, searchFilter);
    }
  }, [page]);

  useEffect(() => {
    window.addEventListener('scroll', debouncedHandleScroll);
    return () => window.removeEventListener('scroll', debouncedHandleScroll);
  }, [debouncedHandleScroll]);

  useEffect(() => {
    if (activeSite != null) {
      fetchShiftsBySiteId();
      fetchAssociatesByMonth(1);
    }
  }, [
    activeSite,
    selectedMonth,
    selectedYear,
    selectedStatus,
    selectedShift,
    selectedShiftDay,
    selectedShiftDate,
    selectedAssociates,
    selectedOTType,
    clientID,
    selectedSiteID,
  ]);

  useEffect(() => {
    if (activeSite != null) {
      fetchStatuses();
    }
  }, [activeSite]);

  useEffect(() => {
    const params = qs.parse(location.search);
    if (selectedDate && params.selectedDate !== selectedDate) {
      history.push({
        pathname: '/smart-scheduler',
        search: qs.stringify({
          ...params,
          spreadsheetViewDate: selectedDate,
        }),
      });
    }
  }, [selectedDate]);

  useEffect(() => {
    const params = qs.parse(location.search);
    if (selectedShiftDate && params.selectedShiftDate !== selectedShiftDate) {
      history.push({
        pathname: '/smart-scheduler',
        search: qs.stringify({
          ...params,
          spreadsheetViewShiftDate: selectedShiftDate,
        }),
      });
    }
  }, [selectedShiftDate]);

  useEffect(() => {
    setPage(1);
    const params = qs.parse(location.search);
    if (
      selectedAssociates &&
      params.selectedAssociates !== selectedAssociates
    ) {
      history.push({
        pathname: '/smart-scheduler',
        search: qs.stringify(
          {
            ...params,
            associateIds: selectedAssociates,
          },
          { arrayFormat: 'repeat' }
        ),
      });
    }
  }, [selectedAssociates]);

  useEffect(() => {
    const params = qs.parse(location.search);
    if (selectedStatus && params.selectedStatus !== selectedStatus) {
      history.push({
        pathname: '/smart-scheduler',
        search: qs.stringify(
          {
            ...params,
            selectedStatus: JSON.stringify(selectedStatus),
          },
          { arrayFormat: 'repeat' }
        ),
      });
    }
  }, [selectedStatus]);

  useEffect(() => {
    const params = qs.parse(location.search);
    if (selectedShift && params.selectedShift !== selectedShift) {
      history.push({
        pathname: '/smart-scheduler',
        search: qs.stringify(
          {
            ...params,
            selectedShift: JSON.stringify(selectedShift),
          },
          { arrayFormat: 'repeat' }
        ),
      });
    }
  }, [selectedShift]);

  useEffect(() => {
    const params = qs.parse(location.search);
    if (selectedShiftDay && params.selectedShiftDay !== selectedShiftDay) {
      history.push({
        pathname: '/smart-scheduler',
        search: qs.stringify(
          {
            ...params,
            selectedShiftDay: JSON.stringify(selectedShiftDay),
          },
          { arrayFormat: 'repeat' }
        ),
      });
    }
  }, [selectedShiftDay]);

  useEffect(() => {
    const params = qs.parse(location.search);
    if (selectedOTType && params.selectedOTType !== selectedOTType) {
      history.push({
        pathname: '/smart-scheduler',
        search: qs.stringify(
          {
            ...params,
            selectedOTType: JSON.stringify(selectedOTType),
          },
          { arrayFormat: 'repeat' }
        ),
      });
    }
  }, [selectedOTType]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="container-fluid" style={{ minWidth: 1350 }}>
      <div
        className="col-12 d-flex align-items-center justify-content-center position-relative pb-3"
        ref={buttonRef}
      >
        {user.is_super && (
          <button
            className="btn btn-outline-brand "
            onClick={() => setShowModalShifts(true)}
            style={{ left: '0', right: 'unset', position: 'absolute' }}
          >
            Manage Shift
          </button>
        )}
        <h6 style={{ fontSize: '1.5rem', margin: 0 }}>
          {new Date(startOfMonth).toLocaleString('en-US', { month: 'long' })}{' '}
          {new Date(startOfMonth).getFullYear()}
        </h6>

        <button
          type="button"
          disabled={false}
          onClick={() => handleAssignAssociate()}
          className="text-search-closing"
          style={{ left: user.is_super ? 135 : 0, right: 'unset' }}
        >
          <i
            className="fas fa-plus"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            style={{ fontSize: 12 }}
          ></i>{' '}
          Assign Shift
        </button>
      </div>
      <div className="row border fw-bold text-muted bg-white">
        <div className="col-2 py-3">
          <Flatpickr
            id="monthYear"
            name="monthYear"
            className="form-control adjust-fs pt-2 text-muted"
            placeholder="Shift Month Period"
            // value={selectedDate}
            onChange={(date) => {
              if (date.length > 0) {
                setSelectedShiftDate('');

                setSelectedDate(
                  `${date[0].getMonth() + 1}-${date[0].getFullYear()}`
                );
                setStartOfMonth(
                  formatDateLocal(
                    new Date(date[0].getFullYear(), date[0].getMonth(), 1)
                  )
                );
                setLastDayOfMonth(
                  formatDateLocal(
                    new Date(date[0].getFullYear(), date[0].getMonth() + 1, 0)
                  )
                );
                setSelectedYear(date[0].getFullYear());
                setSelectedMonth(date[0].getMonth() + 1);
              }
            }}
            options={{
              dateFormat: 'm-Y',
              altFormat: 'm-Y',
              defaultDate: selectedDate || new Date(),
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: 'm-Y',
                  altFormat: 'm-Y',
                }),
              ],
            }}
            style={{ height: 38, borderColor: '#d1d5db', borderRadius: 4 }}
          />
          <div
            className="d-flex align-items-center"
            style={{ position: 'relative' }}
          >
            <Flatpickr
              id="shiftDate"
              name="shiftDate"
              className="form-control adjust-fs pt-2 text-muted"
              placeholder="Shift Date"
              value={selectedShiftDate}
              onChange={(date) => {
                if (date.length > 0) {
                  const year = date[0].getFullYear();
                  const month = String(date[0].getMonth() + 1).padStart(2, '0');
                  const day = String(date[0].getDate()).padStart(2, '0');
                  const formattedDate = `${day}-${month}-${year}`;
                  setSelectedShiftDate(formattedDate);

                  setSelectedDate(
                    `${date[0].getMonth() + 1}-${date[0].getFullYear()}`
                  );
                  setStartOfMonth(
                    formatDateLocal(
                      new Date(date[0].getFullYear(), date[0].getMonth(), 1)
                    )
                  );
                  setLastDayOfMonth(
                    formatDateLocal(
                      new Date(date[0].getFullYear(), date[0].getMonth() + 1, 0)
                    )
                  );
                }
              }}
              options={{
                dateFormat: 'd-m-Y',
                altFormat: 'd-m-Y',
                defaultDate: selectedShiftDate || '',
                minDate: `01-${selectedDate}`,
                maxDate: `${lastDayOfMonth.split('-').reverse().join('-')}`,
              }}
              style={{ height: 38, borderColor: '#d1d5db', borderRadius: 4 }}
            />
            {selectedShiftDate && (
              <button
                type="button"
                onClick={() => {
                  setSelectedShiftDate('');
                }}
                className="text-search-closing"
                title="Clear date"
              >
                ✕
              </button>
            )}
          </div>
        </div>

        <div className="col-2 py-3">
          <div ref={containerRef} className="position-relative">
            <div
              onClick={() => {
                setIsOpen(!isOpen);
                setFilteredAssociates(effectiveAssociateList);
              }}
              className="custom-dropdown-multiple"
            >
              {selectedAssociates.length === 0 ? (
                <span style={{ fontSize: '14px', fontWeight: '400' }}>
                  Select associates...
                </span>
              ) : (
                selectedAssociates.map((item) => (
                  <span key={item} className="chip-selected">
                    {getAssociateDisplayName(item)}
                    <button
                      onClick={(e) => removeItem(item, e)}
                      className="chip-selected-remove"
                      aria-label={`Remove ${item}`}
                    >
                      <i className="fas fa-remove" />
                    </button>
                  </span>
                ))
              )}

              <span
                className="custom-caret-multi-select"
                style={{
                  transform: `translateY(-50%) rotate(${
                    isOpen ? '180deg' : '0deg'
                  })`,
                }}
              >
                <i className="fas fa-chevron-down" />
              </span>
            </div>

            {selectedAssociates.length > 0 && (
              <button
                onClick={clearAll}
                className="remove-all-button-multi-select"
              >
                <i className="fas fa-remove" />
              </button>
            )}

            {isOpen && (
              <div className="custom-multi-select-dropdown">
                <div
                  style={{ padding: '8px', borderBottom: '1px solid #e5e7eb' }}
                >
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      searchHandler(e);
                    }}
                    placeholder="Search..."
                    style={{
                      width: '100%',
                      padding: '6px 10px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px',
                      outline: 'none',
                      fontSize: '14px',
                    }}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
                <ul
                  style={{
                    listStyle: 'none',
                    padding: '4px',
                    margin: '0',
                  }}
                >
                  {filteredAssociates.length === 0 ? (
                    <li
                      style={{
                        padding: '10px',
                        color: '#6b7280',
                        textAlign: 'center',
                        fontSize: '14px',
                      }}
                    >
                      No results found
                    </li>
                  ) : (
                    filteredAssociates.map((associate) => {
                      const isSelected = selectedAssociates.some(
                        (id) => id == associate.id
                      );
                      return (
                        <li
                          key={associate.id}
                          onClick={() =>
                            selectRemoveAssociateHandler(associate.id)
                          }
                          className="custom-multi-select-dropdown-list-item"
                          style={{
                            backgroundColor: isSelected
                              ? '#dbeafe'
                              : 'transparent',
                          }}
                          onMouseEnter={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.backgroundColor = '#f3f4f6';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.backgroundColor =
                                'transparent';
                            }
                          }}
                        >
                          <div className="mx-1">
                            <img
                              className="rounded-circle border me-3"
                              src={
                                associate.image
                                  ? `${SERVER_URL}/${associate.image}`
                                  : placeholderImage
                              }
                              alt="username-img"
                              style={{ height: '35px', width: '35px' }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = placeholderImage;
                              }}
                            />
                          </div>
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <div>
                              {`${associate.first_name} ${associate.last_name}`
                                .length > 18
                                ? `${associate.first_name} ${associate.last_name}`.substring(
                                    0,
                                    18
                                  ) + '...'
                                : `${associate.first_name} ${associate.last_name}`}
                            </div>
                          </div>

                          {isSelected && (
                            <span style={{ color: 'white', fontSize: '12px' }}>
                              ✓
                            </span>
                          )}
                        </li>
                      );
                    })
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
        <div className="col-2 py-3">
          <Select
            value={selectedStatus}
            onChange={(e) => {
              setSelectedStatus(e);
            }}
            isMulti
            options={statuses}
            className="basic-multi-select"
            classNamePrefix="select"
            placeholder="Select Status..."
            isDisabled={statuses.length === 0}
          />
        </div>
        <div className="col-2 py-3">
          <Select
            value={selectedShift}
            onChange={(e) => {
              setSelectedShift(e);
            }}
            isMulti
            options={shifts}
            className="basic-multi-select"
            classNamePrefix="select"
            placeholder="Select Shifts..."
            isDisabled={shifts.length === 0}
          />
        </div>
        <div className="col-2 py-3">
          <Select
            value={selectedShiftDay}
            onChange={(e) => {
              setSelectedShiftDay(e);
            }}
            isMulti
            options={shiftDay}
            className="basic-multi-select"
            classNamePrefix="select"
            placeholder="Select Shift Day..."
          />
        </div>
        <div className="col-2 py-3">
          <Select
            value={selectedOTType}
            onChange={(e) => {
              setSelectedOTType(e);
            }}
            isMulti
            options={OTOptions}
            className="basic-multi-select"
            classNamePrefix="select"
            placeholder="Select OT Type..."
          />
        </div>
      </div>
      <div className="row border-start border-end border-bottom fw-bold text-muted bg-white">
        <div className="py-3" style={{ width: '8%' }}>
          {allSitesSelected ? 'Name / Site' : 'Name'}
        </div>
        <div className="py-3" style={{ width: '10%' }}>
          Status
        </div>
        <div className="py-3" style={{ width: '5%' }}>
          Shift Date
        </div>
        <div className="py-3" style={{ width: '9%' }}>
          Shift Day
        </div>

        <div className="py-3 text-center" style={{ width: '15%' }}>
          Time In
        </div>
        <div className="py-3 text-center" style={{ width: '15%' }}>
          Time Out
        </div>
        <div className="py-3 text-center" style={{ width: '5%' }}>
          <span
            className="d-block hovered-ellipsis"
            onMouseEnter={(e) =>
              handleMouseEnter('header', 'header', 'Total Break', e)
            }
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
          >
            Total Break
          </span>
        </div>
        <div className="py-3 text-center" style={{ width: '9%' }}>
          <span
            className="d-block hovered-ellipsis"
            onMouseEnter={(e) =>
              handleMouseEnter('header', 'header', 'Overtime', e)
            }
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
          >
            Overtime
          </span>
        </div>
        <div className="py-3 text-center" style={{ width: '5%' }}>
          <span
            className="d-block hovered-ellipsis"
            onMouseEnter={(e) =>
              handleMouseEnter('header', 'header', 'Undertime', e)
            }
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
          >
            Undertime
          </span>
        </div>
        <div className="py-3 text-center px-1" style={{ width: '9%' }}>
          Remarks
        </div>
        <div className="py-3 text-center px-1" style={{ width: '5%' }}>
          Last Modified
        </div>
        <div className="px-3" style={{ width: '5%' }}>
          &nbsp;
        </div>
      </div>

      {loadingData ? (
        <div className="row border-start border-end border-bottom fw-bold text-muted bg-white">
          <div className="custom-spinner my-4">
            <div className="double-bounce1"></div>
            <div className="double-bounce2"></div>
          </div>
        </div>
      ) : (
        <>
          {associateSchedule.length > 0 &&
            associateSchedule.map((assoc, index) => {
              const timeIn = assoc.time_in
                ? splitDateTime(assoc.time_in)
                : { date: '', time: '' };

              const timeOut = assoc.time_out
                ? splitDateTime(assoc.time_out)
                : { date: '', time: '' };

              return (
                <div
                  key={`${assoc.associate_id}-${index}`}
                  className={`row adjust-fs row-custom border-bottom border-start border-end align-items-center text-spreadsheet ${
                    index % 2 === 0
                      ? assoc.leave_type != null
                        ? 'bg-orange-custom'
                        : assoc.type === 'Preferred'
                        ? 'bg-blue-custom'
                        : ''
                      : assoc.leave_type != null
                      ? 'bg-orange-custom'
                      : assoc.type === 'Preferred'
                      ? 'bg-blue-custom'
                      : 'bg-white'
                  }`}
                >
                  <div
                    className="py-2 d-block hovered-ellipsis"
                    style={{ width: '8%' }}
                    onMouseEnter={(e) =>
                      handleMouseEnter(
                        assoc.associate_id,
                        'name',
                        `${assoc.first_name} ${assoc.last_name}`,
                        e
                      )
                    }
                    onMouseMove={handleMouseMove}
                    onMouseLeave={handleMouseLeave}
                  >
                    <Link
                      className="text-primary "
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        sidebarHandler(assoc);
                      }}
                    >
                      <span
                        style={{
                          fontWeight: '700',
                          fontSize: 11,
                        }}
                      >
                        {assoc.first_name} {assoc.last_name}
                      </span>
                    </Link>
                    <div className="badge adjust-fs adjust-shadow fw-normal schedule-type">
                      {assoc.is_team_support ? 'Fixed' : 'Flexi'}
                    </div>
                    {allSitesSelected && (
                      <div className="small text-muted mt-1">
                        {assoc.site_name}
                      </div>
                    )}
                  </div>

                  <div className="py-2" style={{ width: '10%' }}>
                    {assoc.leave_type || assoc.type ? (
                      <div
                        className={`badge ${
                          assoc.leave_type
                            ? 'bg-orange-custom'
                            : 'bg-blue-custom'
                        } adjust-fs adjust-shadow fw-normal`}
                        style={{
                          fontSize: 14,
                          color: '#fff',
                          fontWeight: 200,
                          padding: '6px 17px',
                          wordBreak:
                            assoc?.leave_type?.length > 14 ? 'normal' : 'unset',
                          whiteSpace:
                            assoc?.leave_type?.length > 14 ? 'unset' : 'nowrap',
                          textAlign:
                            assoc?.leave_type?.length > 14 ? 'left' : 'center',
                        }}
                      >
                        {assoc.type === 'Preferred'
                          ? assoc.type
                          : assoc.leave_type}
                      </div>
                    ) : (
                      <select
                        name="shiftStatus"
                        id={`shiftStatus_${index}`}
                        className="form-select mt-2 adjust-fs text-muted"
                        value={assoc.status_id}
                        onChange={({ target: { value } }) => {
                          const numValue = Number(value);
                          if (numValue === 1) {
                            handleChange(
                              assoc.associate_schedule_id,
                              'total_overtime',
                              0
                            );
                          } else if (numValue === 2 || numValue === 3) {
                            calculateOvertime(assoc.associate_schedule_id);
                          }

                          handleChange(
                            assoc.associate_schedule_id,
                            'status_id',
                            numValue
                          );
                        }}
                      >
                        {statuses.length > 0 &&
                          statuses
                            .filter((x) => x.value !== 500 && x.value !== 600)
                            .map((status, index) => (
                              <option value={status.value} key={index}>
                                {status.label}
                              </option>
                            ))}
                      </select>
                    )}
                  </div>

                  <div className="py-2" style={{ width: '5%' }}>
                    <span>{assoc.shift_date}</span>
                  </div>

                  <div className="py-2" style={{ width: '9%' }}>
                    <span>{assoc.shift_day}</span>
                  </div>

                  <div className=" py-2 px-2" style={{ width: '15%' }}>
                    <div className="row">
                      {assoc.type === 'Preferred' && (
                        <button
                          type="button"
                          disabled={false}
                          onClick={(e) =>
                            handleAssignToShift(
                              e,
                              assoc.associate_id,
                              assoc.schedule_id
                            )
                          }
                          className="text-search-closing"
                          style={{
                            color: '#1161a7',
                            width: 150,
                            position: 'relative',
                            fontSize: 12,
                          }}
                        >
                          <i
                            className="fas fa-plus"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            style={{ fontSize: 12 }}
                          ></i>{' '}
                          Assign Me
                        </button>
                      )}
                      {!assoc.leave_type && !assoc.type && (
                        <>
                          <div className="col-7 px-1">
                            <div className="">
                              <input
                                style={{ fontSize: 13 }}
                                name="dateTimeIn"
                                id={`dateTimeIn${index}`}
                                type="date"
                                className="form-control"
                                value={timeIn.date || ''}
                                onChange={(e) => {
                                  if (![2, 3, 4, 5].includes(assoc.status_id)) {
                                    ToastUtil.error(
                                      'Please update its status.'
                                    );
                                    return;
                                  }
                                  const newDate = e.target.value;

                                  // Handle clearing the date
                                  if (!newDate) {
                                    handleChange(
                                      assoc.associate_schedule_id,
                                      'time_in',
                                      null
                                    );
                                    setDateTimeIn(null);
                                    setTimeIn(null);
                                    return;
                                  }

                                  const newDateTime = `${newDate} ${
                                    timeIn.time ||
                                    moment(assoc.start_time, 'HH:mm:ss').format(
                                      'HH:mm'
                                    )
                                  }`;

                                  if (
                                    assoc.is_overtime_before ||
                                    assoc.is_overtime_after
                                  ) {
                                    calculateOvertime(
                                      assoc.associate_schedule_id,
                                      'time_in',
                                      newDateTime
                                    );
                                  } else {
                                    handleChange(
                                      assoc.associate_schedule_id,
                                      'time_in',
                                      newDateTime
                                    );
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-5 px-0">
                            <div className="">
                              <input
                                style={{ fontSize: 13, width: 81 }}
                                type="time"
                                className="form-control"
                                name="shiftTimeIn"
                                id={`shiftTimeIn${index}`}
                                placeholder="Shift Time In"
                                value={timeIn.time || ''}
                                onClick={(e) => {
                                  if (!timeIn.date) {
                                    ToastUtil.error(
                                      'Please select a Time In date first.'
                                    );
                                    return false;
                                  }
                                  e.target.showPicker && e.target.showPicker();
                                }}
                                onChange={(e) => {
                                  const newTime = e.target.value;
                                  const newDateTime = `${timeIn.date} ${newTime}`;

                                  if (
                                    assoc.is_overtime_before ||
                                    assoc.is_overtime_after
                                  ) {
                                    calculateOvertime(
                                      assoc.associate_schedule_id,
                                      'time_in',
                                      newDateTime
                                    );
                                  } else {
                                    handleChange(
                                      assoc.associate_schedule_id,
                                      'time_in',
                                      newDateTime
                                    );
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div className=" py-2 px-2" style={{ width: '15%' }}>
                    <div className="row">
                      {!assoc.leave_type && !assoc.type && (
                        <>
                          <div className="col-7 px-2">
                            <div className="">
                              <input
                                style={{ fontSize: 13, width: 111 }}
                                name="dateTimeOut"
                                id={`dateTimeOut${index}`}
                                type="date"
                                className="form-control"
                                value={timeOut.date || ''}
                                onChange={(e) => {
                                  if (![2, 3, 4, 5].includes(assoc.status_id)) {
                                    ToastUtil.error('Please change status.');
                                    return;
                                  }
                                  const newDate = e.target.value;

                                  // Handle clearing the date
                                  if (!newDate) {
                                    handleChange(
                                      assoc.associate_schedule_id,
                                      'time_out',
                                      null
                                    );
                                    setDateTimeOut(null);
                                    setTimeOut(null);
                                    return;
                                  }

                                  const newDateTime = `${newDate} ${
                                    timeOut.time ||
                                    moment(assoc.end_time, 'HH:mm:ss').format(
                                      'HH:mm'
                                    )
                                  }`;

                                  if (
                                    assoc.is_overtime_before ||
                                    assoc.is_overtime_after
                                  ) {
                                    calculateOvertime(
                                      assoc.associate_schedule_id,
                                      'time_out',
                                      newDateTime
                                    );
                                  } else {
                                    handleChange(
                                      assoc.associate_schedule_id,
                                      'time_out',
                                      newDateTime
                                    );
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-5 px-0">
                            <div className="">
                              <input
                                style={{ fontSize: 13, width: 81 }}
                                type="time"
                                className="form-control"
                                id={`shiftTimeOut${index}`}
                                name="shiftTimeOut"
                                placeholder="Shift Time In"
                                value={timeOut.time || ''}
                                onClick={(e) => {
                                  if (!timeOut.date) {
                                    ToastUtil.error(
                                      'Please select a Time Out date first.'
                                    );
                                    return false;
                                  }
                                  e.target.showPicker && e.target.showPicker();
                                }}
                                onChange={(e) => {
                                  const newTime = e.target.value;

                                  // Handle clearing the time
                                  if (!newTime || !timeOut.date) {
                                    // If time is cleared, just update time part or clear entirely
                                    if (!newTime) {
                                      handleChange(
                                        assoc.associate_schedule_id,
                                        'time_out',
                                        null
                                      );
                                      setTimeOut(null);
                                    }
                                    return;
                                  }

                                  const newDateTime = `${timeOut.date} ${newTime}`;

                                  if (
                                    assoc.is_overtime_before ||
                                    assoc.is_overtime_after
                                  ) {
                                    calculateOvertime(
                                      assoc.associate_schedule_id,
                                      'time_out',
                                      newDateTime
                                    );
                                  } else {
                                    handleChange(
                                      assoc.associate_schedule_id,
                                      'time_out',
                                      newDateTime
                                    );
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="py-2 text-center" style={{ width: '5%' }}>
                    {!assoc.leave_type && !assoc.type && (
                      <>
                        <span>{assoc.total_break}</span>
                      </>
                    )}
                  </div>

                  <div className="py-2 text-center" style={{ width: '9%' }}>
                    {!assoc.leave_type && !assoc.type && (
                      <>
                        <div className="form-check spreadsheet-checkbox">
                          <input
                            id={`beforeShift${index}`}
                            name="beforeShift"
                            className="form-check-input"
                            type="checkbox"
                            checked={assoc.is_overtime_before}
                            onChange={(e) => {
                              const timeIn = assoc.time_in
                                ? splitDateTime(assoc.time_in)
                                : { date: '', time: '' };

                              if (assoc.status_id === 1) {
                                ToastUtil.error(
                                  'Status should be changed to "On Time".'
                                );
                                return;
                              }

                              if (!assoc.is_overtime_before && !timeIn.date) {
                                ToastUtil.error(
                                  'Time In is required for Overtime - Before Shift.'
                                );
                                return;
                              }

                              calculateOvertime(
                                assoc.associate_schedule_id,
                                'is_overtime_before',
                                e.target.checked
                              );
                            }}
                          />
                          <label
                            className="ms-2"
                            htmlFor={`beforeShift${index}`}
                          >
                            Before Shift
                          </label>
                        </div>
                        <div className="form-check spreadsheet-checkbox">
                          <input
                            id={`afterShift${index}`}
                            name="afterShift"
                            className="form-check-input"
                            type="checkbox"
                            checked={assoc.is_overtime_after}
                            onChange={(e) => {
                              const timeOut = assoc.time_out
                                ? splitDateTime(assoc.time_out)
                                : { date: '', time: '' };

                              if (!assoc.is_overtime_after && !timeOut.date) {
                                ToastUtil.error(
                                  'Time Out is required for Overtime - After Shift.'
                                );
                                return;
                              }

                              calculateOvertime(
                                assoc.associate_schedule_id,
                                'is_overtime_after',
                                e.target.checked
                              );
                            }}
                          />
                          <label
                            className="ms-2"
                            htmlFor={`afterShift${index}`}
                          >
                            After Shift
                          </label>
                        </div>
                        <div className="text-start">
                          {assoc.total_overtime > 0 && (
                            <>
                              <span>
                                CO: {assoc.total_overtime.toFixed(2)}hrs
                              </span>
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  <div className="py-2 text-center" style={{ width: '5%' }}>
                    {!assoc.leave_type && !assoc.type && (
                      <>
                        <div className="form-check d-inline-block">
                          <input
                            id={`undertime${index}`}
                            name="undertime"
                            className="form-check-input"
                            type="checkbox"
                            checked={assoc.is_undertime}
                            onChange={() =>
                              handleChange(
                                assoc.associate_schedule_id,
                                'is_undertime',
                                !assoc.is_undertime
                              )
                            }
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className="py-2 text-center px-1"
                    style={{ width: '9%' }}
                  >
                    {!assoc.leave_type && !assoc.type && (
                      <>
                        <input
                          style={{ fontSize: 13 }}
                          name="remarks"
                          id={`remarks${index}`}
                          type="text"
                          className="form-control"
                          value={assoc.remarks || ''}
                          onChange={(e) =>
                            handleChange(
                              assoc.associate_schedule_id,
                              'remarks',
                              e.target.value
                            )
                          }
                        />
                      </>
                    )}
                  </div>
                  <div
                    className="py-2 text-center px-1"
                    style={{ width: '5%' }}
                  >
                    {!assoc.leave_type && !assoc.type && assoc.date_modified}
                  </div>
                  <div className="py-1 text-center" style={{ width: '5%' }}>
                    {!assoc.leave_type && !assoc.type && (
                      <>
                        <button
                          className={`btn btn-sm ${
                            assoc?.has_changes ? 'btn-primary' : 'btn-secondary'
                          }`}
                          disabled={!assoc?.has_changes}
                          onClick={() => {
                            saveAssociateSchedule(
                              assoc.associate_id,
                              assoc.sched_id,
                              assoc.associate_schedule_id
                            );
                          }}
                        >
                          Save
                        </button>
                      </>
                    )}
                  </div>
                </div>
              );
            })}

          {hoveredItem && (
            <div
              className="hovered-item"
              style={{
                left: mousePosition.x + 10,
                top: mousePosition.y - 30,
              }}
            >
              {hoveredItem.content}
            </div>
          )}

          {pullingData && (
            <div className="row border-start border-end border-bottom fw-bold text-muted bg-white">
              <div className="custom-spinner my-4">
                <div className="double-bounce1"></div>
                <div className="double-bounce2"></div>
              </div>
            </div>
          )}

          {loadingData && hasMore ? (
            <p style={{ textAlign: 'center', marginTop: 45 }}>Loading...</p>
          ) : (
            associateSchedule.length > 0 && (
              <p style={{ textAlign: 'center', marginTop: 20 }}></p>
            )
          )}

          {associateSchedule.length == 0 && !hasMore && (
            <p style={{ textAlign: 'center', marginTop: 20 }}>
              No records found.
            </p>
          )}
        </>
      )}
      <AssociateSidebar
        activeSite={activeSite}
        setSpreadsheetViewAssignShift={setSpreadsheetViewAssignShift}
        spreadsheetViewAssignShift={spreadsheetViewAssignShift}
        startOfMonth={startOfMonth}
        lastDayOfMonth={lastDayOfMonth}
        shifts={shifts}
        fetchAssociatesByMonth={fetchAssociatesByMonth}
        selectedSiteID={selectedSiteID}
        sites={sites}
      />
      <ActivitySidebar
        associate={selectedAssociate}
        activeSidebar={activeSidebar}
        setActiveSidebar={setActiveSidebar}
      />
    </div>
  );
};

export default withRouter(SpreadsheetView);
